import {Route, Routes} from 'react-router-dom';
import {LoginRoutes, LogoutRoutes, SignupPage} from '@tinct/web-feature-login';
import {LegacyOutreachDemoRedirect} from './legacy-outreach-demo-redirect';
import {ProtectedRoutes} from './protected-routes';
import {ProtectedPage} from '@tinct/core-store-session';
import {KonamiCodePage} from './konami-code-page';

export const RootRoutes = () => {
  return (
    <Routes>
      <Route path="/login/*" element={<LoginRoutes />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/logout/*" element={<LogoutRoutes />} />
      {/* The outreach demo previewer moved to its own app (see.tinct.ai); older share links land here. */}
      <Route path="/demo/:id" element={<LegacyOutreachDemoRedirect />} />
      <Route element={<ProtectedPage />}>
        <Route path="/konami-code" element={<KonamiCodePage />} />
        <Route path="*" element={<ProtectedRoutes />} />
      </Route>
    </Routes>
  );
};
